import { Button, Form, Input, InputNumber, Modal, Select, message } from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { refresh } from "../../store/adminSlice";

const { Option } = Select;
const { TextArea } = Input;

const SOURCE_OPTIONS = [
  "order",
  "signup",
  "referral",
  "redeem",
  "gift",
  "other",
  "admin_remove",
];

export default function LoyaltyPointsForm({
  visible,
  onCancel,
  onSuccess,
  userId,
  userName = "",
  action = "add", // "add" or "remove"
  isDarkMode = false,
}) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      const endpoint =
        action === "add"
          ? "/loyalty/api/v1/admin/loyalty-points/add/"
          : "/loyalty/api/v1/admin/loyalty-points/remove/";

      const payload = {
        user: userId,
        points: values.points,
        source: values.source,
        message: values.message || "",
      };

      if (action === "add") {
        payload.is_active =
          values.is_active !== undefined ? values.is_active : true;
      }

      await axios.post(endpoint, payload);

      const successMessage =
        action === "add"
          ? "Points added successfully"
          : "Points removed successfully";
      message.success(successMessage);

      form.resetFields();
      onSuccess?.();
    } catch (err) {
      if (err.response?.status === 401 && Cookies.get("logss")) {
        dispatch(refresh()).then(() => handleSubmit(values));
      } else if (err.response?.status === 401 && !Cookies.get("logss")) {
        navigate("/");
      } else {
        const apiMsg =
          err.response?.data?.detail ||
          err.response?.data?.message ||
          `Failed to ${action} points`;
        message.error(apiMsg);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel?.();
  };

  const getModalTitle = () => {
    const actionText = action === "add" ? "Add" : "Remove";
    const userText = userName ? ` for ${userName}` : "";
    return `${actionText} Loyalty Points${userText}`;
  };

  return (
    <Modal
      title={getModalTitle()}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      className={isDarkMode ? "dark-ant-modal" : ""}
      centered
      afterOpenChange={(open) => {
        if (open && userId) {
          form.setFieldsValue({
            user: userId,
            source: action === "remove" ? "admin_remove" : undefined,
            is_active: action === "add" ? true : undefined,
          });
        }
      }}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="user" label="User ID">
          <InputNumber
            style={{ width: "100%" }}
            placeholder="Enter user ID"
            disabled
          />
        </Form.Item>

        <Form.Item
          name="points"
          label={action === "add" ? "Points" : "Points to Remove"}
          rules={[
            {
              required: true,
              message: `Please enter points to ${action}`,
            },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            placeholder={`Enter points to ${action}`}
            min={0}
          />
        </Form.Item>

        <Form.Item
          name="source"
          label="Source"
          rules={[{ required: true, message: "Please select source" }]}
        >
          <Select placeholder="Select source">
            {SOURCE_OPTIONS.filter((option) =>
              action === "add"
                ? option !== "admin_remove"
                : option === "admin_remove",
            ).map((source) => (
              <Option value={source} key={source}>
                {source.charAt(0).toUpperCase() + source.slice(1)}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="message" label="Message (Optional)">
          <TextArea
            rows={3}
            placeholder={
              action === "add" ? "Enter message" : "Enter reason for removal"
            }
          />
        </Form.Item>

        {action === "add" && (
          <Form.Item name="is_active" label="Active Status" initialValue={true}>
            <Select>
              <Option value={true}>Active</Option>
              <Option value={false}>Inactive</Option>
            </Select>
          </Form.Item>
        )}

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={submitting}
            style={{ marginRight: 8 }}
            danger={action === "remove"}
          >
            {action === "add" ? "Add Points" : "Remove Points"}
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
